import { render, staticRenderFns } from "./MobileTrainingQuiz.vue?vue&type=template&id=4c661db2&scoped=true"
import script from "./MobileTrainingQuiz.vue?vue&type=script&lang=js"
export * from "./MobileTrainingQuiz.vue?vue&type=script&lang=js"
import style0 from "./MobileTrainingQuiz.vue?vue&type=style&index=0&id=4c661db2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c661db2",
  null
  
)

export default component.exports